"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FARMING_MODULE_KEYS = exports.INSURANCE_MODULE_KEYS = exports.MODULE_KEYS = exports.ACCESS_MODULE_CATALOG = exports.PACKAGE_REQUIRED_SERVICE_KEYS = exports.PACKAGE_SCOPED_SERVICE_KEYS = exports.FARMING_SERVICE_MODULE_KEYS = exports.INSURANCE_SERVICE_MODULE_KEYS = exports.TENANT_PACKAGE_DESCRIPTIONS = exports.TENANT_PACKAGE_LABELS = exports.INDUSTRY_OPTIONS = void 0;
exports.normalizeIndustrySelection = normalizeIndustrySelection;
exports.normalizeIndustryValue = normalizeIndustryValue;
exports.resolveTenantPackage = resolveTenantPackage;
exports.industryFromTenantPackage = industryFromTenantPackage;
exports.isInsuranceIndustry = isInsuranceIndustry;
exports.isFarmingIndustry = isFarmingIndustry;
exports.isFarmerIndustry = isFarmerIndustry;
exports.applyIndustryServiceBundle = applyIndustryServiceBundle;
exports.isSameServiceSelection = isSameServiceSelection;
exports.INDUSTRY_OPTIONS = [
    { value: 'logistics', label: 'Logistics & Transport', packageType: 'core' },
    {
        value: 'insurance',
        label: 'Insurance Telematics',
        packageType: 'insurance',
    },
    { value: 'mining', label: 'Mining', packageType: 'core' },
    { value: 'farming', label: 'Livestock & Farming', packageType: 'farming' },
    { value: 'public_transport', label: 'Public Transport', packageType: 'core' },
    { value: 'ride_hailing', label: 'Ride Hailing', packageType: 'core' },
    { value: 'construction', label: 'Construction', packageType: 'core' },
    { value: 'delivery', label: 'Delivery & Courier', packageType: 'core' },
    { value: 'waste', label: 'Waste Management', packageType: 'core' },
    { value: 'security', label: 'Security & Response', packageType: 'core' },
    { value: 'other', label: 'Other', packageType: 'core' },
];
exports.TENANT_PACKAGE_LABELS = {
    core: 'Core Fleet Package',
    insurance: 'Insurance Telematics Package',
    farming: 'Farming Telematics Package',
};
exports.TENANT_PACKAGE_DESCRIPTIONS = {
    core: 'Base fleet stack with maps, devices, alerts, users, and reports.',
    insurance: 'Insurance modules for UBI, claims automation, underwriting, fraud, and insurer integrations.',
    farming: 'Farming modules for livestock telemetry, land geofences, farm operations, and agri reports.',
};
exports.INSURANCE_SERVICE_MODULE_KEYS = [
    'ubi',
    'insurance-telemetry',
    'insurance-crash-claims',
    'insurance-risk-portfolio',
    'insurance-underwriting',
    'insurance-api-gateway',
    'insurance-fraud-compliance',
    'insurance-leaderboard-incentive',
];
exports.FARMING_SERVICE_MODULE_KEYS = ['farmersTelemetry'];
exports.PACKAGE_SCOPED_SERVICE_KEYS = [
    ...exports.INSURANCE_SERVICE_MODULE_KEYS,
    ...exports.FARMING_SERVICE_MODULE_KEYS,
];
exports.PACKAGE_REQUIRED_SERVICE_KEYS = {
    core: [],
    insurance: [...exports.INSURANCE_SERVICE_MODULE_KEYS, 'billing', 'reports'],
    farming: [...exports.FARMING_SERVICE_MODULE_KEYS, 'billing', 'reports'],
};
const INSURANCE_ALIASES = new Set([
    'insurance',
    'insurer',
    'insurance_ubi',
    'insurance_telematics',
    'ubi_insurance',
]);
const FARMING_ALIASES = new Set([
    'farmer',
    'farm',
    'farming',
    'agriculture',
    'agri',
    'livestock',
    'livestock_farming',
    'agritech',
]);
function normalizeIndustrySelection(industry) {
    if (!industry)
        return '';
    const normalized = industry
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_');
    if (!normalized)
        return '';
    if (INSURANCE_ALIASES.has(normalized) || normalized.includes('insurance')) {
        return 'insurance';
    }
    if (FARMING_ALIASES.has(normalized) ||
        normalized.includes('farm') ||
        normalized.includes('livestock') ||
        normalized.includes('agri')) {
        return 'farming';
    }
    return normalized;
}
function normalizeIndustryValue(industry) {
    const normalized = normalizeIndustrySelection(industry);
    return normalized || undefined;
}
function resolveTenantPackage(industry) {
    const normalized = normalizeIndustrySelection(industry);
    if (normalized === 'insurance')
        return 'insurance';
    if (normalized === 'farming')
        return 'farming';
    return 'core';
}
function industryFromTenantPackage(tenantPackage) {
    const normalized = String(tenantPackage || '').trim().toLowerCase();
    if (normalized === 'insurance')
        return 'insurance';
    if (normalized === 'farming' || normalized === 'farmer')
        return 'farming';
    return '';
}
function isInsuranceIndustry(industry) {
    return resolveTenantPackage(industry) === 'insurance';
}
function isFarmingIndustry(industry) {
    return resolveTenantPackage(industry) === 'farming';
}
function isFarmerIndustry(industry) {
    return isFarmingIndustry(industry);
}
function applyIndustryServiceBundle(currentServices, industry) {
    const packageType = resolveTenantPackage(industry);
    const next = new Set(Array.from(currentServices || []));
    for (const packageService of exports.PACKAGE_SCOPED_SERVICE_KEYS) {
        next.delete(packageService);
    }
    for (const required of exports.PACKAGE_REQUIRED_SERVICE_KEYS[packageType]) {
        next.add(required);
    }
    return Array.from(next);
}
function isSameServiceSelection(left, right) {
    const a = Array.from(left || []);
    const b = Array.from(right || []);
    if (a.length !== b.length)
        return false;
    const setB = new Set(b);
    return a.every((service) => setB.has(service));
}
exports.ACCESS_MODULE_CATALOG = [
    {
        key: 'map',
        name: 'Live Map',
        description: 'Real-time fleet tracking',
        category: 'core',
        route: 'map',
        isInsurance: false,
        sortOrder: 10,
    },
    {
        key: 'cameras',
        name: 'Video Studio',
        description: 'Multi-channel video feeds',
        category: 'core',
        route: 'cameras',
        isInsurance: false,
        sortOrder: 20,
    },
    {
        key: 'vehicles',
        name: 'Vehicle Manager',
        description: 'Vehicle management',
        category: 'core',
        route: 'vehicles',
        isInsurance: false,
        sortOrder: 30,
    },
    {
        key: 'fleet',
        name: 'Fleet Control',
        description: 'Fleet operations',
        category: 'core',
        route: 'fleet',
        isInsurance: false,
        sortOrder: 40,
    },
    {
        key: 'devices',
        name: 'Device Hub',
        description: 'Hardware provisioning',
        category: 'core',
        route: 'devices',
        isInsurance: false,
        sortOrder: 50,
    },
    {
        key: 'alerts',
        name: 'Alerts Center',
        description: 'Alert management',
        category: 'core',
        route: 'alerts',
        isInsurance: false,
        sortOrder: 60,
    },
    {
        key: 'users',
        name: 'User Directory',
        description: 'User management',
        category: 'core',
        route: 'users',
        isInsurance: false,
        sortOrder: 70,
    },
    {
        key: 'settings',
        name: 'Settings Hub',
        description: 'System configuration',
        category: 'core',
        route: 'settings',
        isInsurance: false,
        sortOrder: 80,
    },
    {
        key: 'video',
        name: 'Video Console',
        description: 'Camera configuration',
        category: 'core',
        route: 'video',
        isInsurance: false,
        sortOrder: 90,
        legacyServiceKeys: ['cameras'],
    },
    {
        key: 'support',
        name: 'Support Hub',
        description: 'Help and documentation',
        category: 'core',
        route: 'support',
        isInsurance: false,
        sortOrder: 100,
    },
    {
        key: 'management',
        name: 'Ops Console',
        description: 'Advanced tooling',
        category: 'core',
        route: 'management',
        isInsurance: false,
        sortOrder: 110,
    },
    {
        key: 'engine-room',
        name: 'Engine Room',
        description: 'System monitoring',
        category: 'core',
        route: 'engine-room',
        isInsurance: false,
        sortOrder: 120,
    },
    {
        key: 'reports',
        name: 'Reports and Analytics',
        description: 'Analytics and reports',
        category: 'core',
        route: 'reports',
        isInsurance: false,
        sortOrder: 130,
    },
    {
        key: 'billing',
        name: 'Billing Console',
        description: 'Financial management',
        category: 'core',
        route: 'billing',
        isInsurance: false,
        sortOrder: 140,
    },
    {
        key: 'articles',
        name: 'Articles',
        description: 'Blog and content management',
        category: 'content',
        route: 'articles',
        isInsurance: false,
        sortOrder: 150,
    },
    {
        key: 'replays',
        name: 'Replay Studio',
        description: 'Telemetry playback',
        category: 'core',
        route: null,
        isInsurance: false,
        sortOrder: 160,
    },
    {
        key: 'triggers',
        name: 'Trigger Engine',
        description: 'Automation rules',
        category: 'core',
        route: null,
        isInsurance: false,
        sortOrder: 170,
    },
    {
        key: 'farmersTelemetry',
        name: 'Farmers Telemetry',
        description: 'Livestock, land, and work management for farm operations',
        category: 'farming',
        route: 'farmers-telemetry',
        isInsurance: false,
        sortOrder: 180,
    },
    {
        key: 'insurance-telemetry',
        name: 'Insurance Telemetry',
        description: 'Insurance telemetry operations interface',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 200,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-crash-claims',
        name: 'Crash and claims automation',
        description: 'Crash forensics and claim evidence automation',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 210,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-risk-portfolio',
        name: 'Risk portfolio command center',
        description: 'Portfolio-level risk analytics and trend monitoring',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 220,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-underwriting',
        name: 'Underwriting workbench',
        description: 'Usage-based underwriting controls and scoring',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 230,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-api-gateway',
        name: 'Insurance API gateway',
        description: 'API status and Guidewire/Salesforce integration controls',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 240,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-fraud-compliance',
        name: 'Fraud and compliance guardrails',
        description: 'POPIA/GDPR controls with fraud and anomaly detection',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 250,
        legacyServiceKeys: ['ubi'],
    },
    {
        key: 'insurance-leaderboard-incentive',
        name: 'Leaderboard and incentive engine',
        description: 'Behavior leaderboard and incentive orchestration',
        category: 'insurance',
        route: 'insurance',
        isInsurance: true,
        sortOrder: 260,
        legacyServiceKeys: ['ubi'],
    },
];
exports.MODULE_KEYS = exports.ACCESS_MODULE_CATALOG.map((module) => module.key);
exports.INSURANCE_MODULE_KEYS = exports.ACCESS_MODULE_CATALOG.filter((module) => module.isInsurance).map((module) => module.key);
exports.FARMING_MODULE_KEYS = exports.ACCESS_MODULE_CATALOG.filter((module) => module.category === 'farming').map((module) => module.key);
